import { useState, useRef, useCallback } from "react";
import { FaChair, FaChevronDown } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import PortalDropdown from "./PortalDropdown";

const TableDropdown = ({ guest, tables, onSelect }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const handleClose = useCallback(() => setOpen(false), []);

    const currentTable = tables.find(t => t._id === (guest.reservedTableId?._id || guest.reservedTableId));
    const guestSeatsOccupied = 1 + (guest.companions?.unregistered || 0);
    const availableTables = tables.filter(t =>
        t._id !== (guest.reservedTableId?._id || guest.reservedTableId) &&
        (t.seats - t.reservedSeats) >= guestSeatsOccupied
    );

    return (
        <div ref={anchorRef}>
            <button
                onClick={() => setOpen(o => !o)}
                className="w-full flex items-center justify-between gap-2 px-3 py-2 bg-white border border-gray-200 rounded-xl text-sm text-gray-700 hover:border-rose-300 hover:bg-rose-50 transition-all"
            >
                <span className="flex items-center gap-2">
                    <FaChair className="text-gray-400 text-xs flex-shrink-0" />
                    <span className="truncate capitalize">
                        {currentTable ? currentTable.name : (t('noReservation') || 'Bez stola')}
                    </span>
                </span>
                <FaChevronDown className={`text-xs text-gray-400 flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
            </button>
            <PortalDropdown anchorRef={anchorRef} open={open} onClose={handleClose}>
                <div className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
                    {availableTables.length === 0 && !currentTable && (
                        <p className="px-4 py-3 text-sm text-gray-400 text-center">Nema dostupnih stolova</p>
                    )}
                    {availableTables.map(table => (
                        <button
                            key={table._id}
                            onMouseDown={() => { onSelect(guest._id, table); setOpen(false); }}
                            className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-left hover:bg-rose-50 transition border-b border-gray-50 last:border-0"
                        >
                            <span className="capitalize font-medium text-gray-800">{table.name}</span>
                            <span className="text-xs text-gray-400">{table.reservedSeats}/{table.seats}</span>
                        </button>
                    ))}
                    {currentTable && (
                        <button
                            onMouseDown={() => { onSelect(guest._id, null); setOpen(false); }}
                            className="w-full px-4 py-2.5 text-sm text-left text-red-500 hover:bg-red-50 transition border-t border-gray-100"
                        >
                            {t('removeReservation') || 'Ukloni rezervaciju'}
                        </button>
                    )}
                </div>
            </PortalDropdown>
        </div>
    );
};

export default TableDropdown;
